/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Due_HoursInputs */

const cs_automation_due_hours = /** @type {(inputs: Automation_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splatnost (hodiny)`)
};

const en_automation_due_hours = /** @type {(inputs: Automation_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due in (hours)`)
};

/**
* | output |
* | --- |
* | "Due in (hours)" |
*
* @param {Automation_Due_HoursInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_due_hours = /** @type {((inputs?: Automation_Due_HoursInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Due_HoursInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_due_hours(inputs)
	return cs_automation_due_hours(inputs)
});